import { useCallback } from 'react'

interface Results {
  correct: boolean
  distance: number
  level: number
}

export function useGeneratePoints() {
  const calcPoints = useCallback((results: Results) => {
    const totalPoints = {
      correctness: 0,
      closeness: 0,
      level: 0,
    }
    const maxDistance = 3000
    // Correctness
    if (results.correct) {
      totalPoints.correctness += 100

      //bonus points for level
      // if (results.level === 2) {
      //   totalPoints.level += 15
      // } else if (results.level === 3) {
      //   totalPoints.level += 30
      // }

      // closeness
    } else {
      if (results.distance <= maxDistance) {
        const closenessPoints = Math.round(
          50 * (1 - results.distance / maxDistance)
        )
        totalPoints.closeness += closenessPoints
      }
    }

    return totalPoints
  }, [])

  return { calcPoints }
}
